import React from 'react';
import { Snackbar, Alert, Stack } from '@mui/material';
import { useNotification } from '@/contexts/NotificationContext';

/**
 * Toast notifications component that displays temporary messages
 * from the NotificationContext (eventBus notifications)
 */
export const ToastNotifications: React.FC = () => {
  const { notifications, removeNotification } = useNotification();

  return (
    <Stack spacing={1} sx={{ position: 'fixed', top: 80, right: 16, zIndex: 9999 }}>
      {notifications.map(notification => (
        <Snackbar
          key={notification.id}
          open={true}
          autoHideDuration={notification.duration || 4000}
          onClose={() => removeNotification(notification.id)}
        >
          <Alert
            onClose={() => removeNotification(notification.id)}
            severity={notification.type}
            variant="filled"
            sx={{ minWidth: 300 }}
          >
            {notification.message}
          </Alert>
        </Snackbar>
      ))}
    </Stack>
  );
};
